<template>
  <div class="login_pop" v-if="seen">
    <div class="form" @keyup="hide">
      <div class="signin">
        <span class="logo">
          <img src="@/assets/logo-small-blue.png" />
        </span>
        <span>
          <strong>
            Sign in to continue
          </strong>
        </span>
        <span class="tagline">
          Your login session has expired
        </span>
      </div>
      <div class="error animated slideInUp" v-if="error.error">
        Incorrect login details
      </div>
      <div>
        <label>Email Address</label>
        <input type="text" v-model="email" placeholder="Email" />
        <span class="error" v-if="error.email">*Required</span>
      </div>
      <div>
        <label>Password</label>
        <input type="password" v-model="password" placeholder="Password" />
        <span class="error" v-if="error.password">*Required</span>
      </div>
      <div class="btn">
        <template v-if="!loader">
          <button type="button" @click="submit">Login</button>
        </template>
        <template v-if="loader">
          <button type="button" disabled>Signing...</button>
        </template>
        <!--<span v-if="loader">
                    <svg width="80px"  height="80px"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-dual-ring" style="background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;"><circle cx="50" cy="50" fill="none" stroke-linecap="round" r="20" stroke-width="4" stroke="#039aed" stroke-dasharray="31.41592653589793 31.41592653589793"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></circle></svg>
                </span>-->
      </div>
    </div>
  </div>
</template>
<style scoped>
.btn {
  padding: 0 !important;
}
</style>
<script>
import AuthenticationService from '../services/AuthenticationService'

export default {
  data() {
    return {
      email: '',
      password: '',
      error: {
        email: false,
        password: false,
        error: false
      },
      post: true,
      seen: false,
      loader: false,
      reload: false
    }
  },
  methods: {
    load(reload = false) {
      console.log('oooooop')
      this.reload = reload
      this.seen = true
      sessionStorage.removeItem('status')
    },
    hide(evt) {
      this.error.error = false

      if (evt.keyCode == 13) {
        this.post = true
        this.error.error = false

        if (this.email === '') {
          this.error.email = true
          this.post = false
        } else {
          this.error.email = false
        }

        if (this.password === '') {
          this.error.password = true
          this.post = false
        } else {
          this.error.password = false
        }

        if (this.post) {
          this.loader = true

          let that = this
          let data = {
            email: this.email,
            password: this.password
          }

          AuthenticationService.ulogin(data).then(res => {
            if (res.data.data === true) {
              if (localStorage.getItem('email') === res.data.email) {
                that.loader = false
                that.seen = false
                that.email = ''
                that.password = ''
                // cookies.setCookie('token', data.token, 6 * 60 * 60 * 1000)
                sessionStorage.setItem('status', true)
                if (that.reload) that.$parent.reload()
              } else {
                that.loader = false
                that.seen = false
                that.email = ''
                that.password = ''
                localStorage.removeItem('current_directory_id')
                // cookies.setCookie('token', data.token, 6 * 60 * 60 * 1000)
                sessionStorage.setItem('status', false)
                that.$router.push('/login')
                // window.location.reload(true)
              }
            }

            if (res.data.data === false) {
              that.loader = false
              that.error.error = true
              that.$router.push('/login')
            }
          }).catch(err => {
            console.log(err)
          })
        }
      }
    },
    submit() {
      this.post = true
      this.error.error = false

      if (this.email === '') {
        this.error.email = true
        this.post = false
      } else {
        this.error.email = false
      }

      if (this.password === '') {
        this.error.password = true
        this.post = false
      } else {
        this.error.password = false
      }

      if (this.post) {
        this.loader = true

        let that = this
        let data = {
          email: this.email,
          password: this.password
        }

        AuthenticationService.ulogin(data).then(res => {
          if (res.data.data === true) {
            if (localStorage.getItem('email') === res.data.email) {
              that.loader = false
              that.seen = false
              that.email = ''
              that.password = ''
              // cookies.setCookie('token', data.token, 6 * 60 * 60 * 1000)
              sessionStorage.setItem('status', true)
              if (that.reload) that.$parent.reload()
            } else {
              that.loader = false
              that.seen = false
              that.email = ''
              that.password = ''
              localStorage.removeItem('current_directory_id')
              // cookies.setCookie('token', data.token, 6 * 60 * 60 * 1000)
              sessionStorage.setItem('status', false)
              that.$router.push('/login')
              // window.location.reload(true)
            }
          }

          if (res.data.data === false) {
            that.loader = false
            that.error.error = true
            that.$router.push('/login')
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
}
</script>
